// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../state/gerenciarUsuarios/actions';

// Components
import AccessLog from '../components/ManageUser/AccessLog';

function mapStateToProps(state) {
	return {
		isFetching: state.lUsers.isFetching,
		access_log: state.lUsers.logs.access_log,
		pagination: state.lUsers.logs.pagination,
		filter: state.lUsers.logs.filter
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessLog);


// WEBPACK FOOTER //
// ./src/containers/AccessLogContainer.js